import { render, staticRenderFns } from "./RubricAchievementForm.vue?vue&type=template&id=74a2e526&scoped=true"
import script from "./RubricAchievementForm.vue?vue&type=script&lang=js"
export * from "./RubricAchievementForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=74a2e526&prod&scoped=true&lang=css&external"
import style1 from "./RubricAchievementForm.vue?vue&type=style&index=1&id=74a2e526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2e526",
  null
  
)

export default component.exports